import React from 'react';

interface ClaimOverviewCardProps {
  createdAt: string;
  completedAt?: string;
  eventType?: string;
  coverageYear?: number;
}

export const ClaimOverviewCard: React.FC<ClaimOverviewCardProps> = ({
  createdAt,
  completedAt,
  eventType,
  coverageYear,
}) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
        <h2 className="font-semibold text-gray-900">Claim Overview</h2>
        <div className="text-sm text-gray-500">
          Created {new Date(createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          {completedAt && ` • Completed ${new Date(completedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`}
        </div>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <p className="text-sm text-gray-500 mb-1">Created</p>
            <p className="font-medium text-gray-900">{new Date(createdAt).toLocaleString()}</p>
          </div>
          {completedAt && (
            <div>
              <p className="text-sm text-gray-500 mb-1">Completed</p>
              <p className="font-medium text-gray-900">{new Date(completedAt).toLocaleString()}</p>
            </div>
          )}
          {eventType && (
            <div>
              <p className="text-sm text-gray-500 mb-1">Event Type</p>
              <p className="font-medium text-gray-900 capitalize">{eventType}</p>
            </div>
          )}
          {coverageYear && (
            <div>
              <p className="text-sm text-gray-500 mb-1">Coverage Year</p>
              <p className="font-medium text-gray-900">{coverageYear}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClaimOverviewCard;
